export { default } from './appointment.service'
export * from './appointment.types'
